import { ModalWithTwoFaProps } from 'src/components/modal-with-two-fa/ModalWithTwoFa';

export enum AccountSecurityInputs {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  PASSWORD = 'PASSWORD',
}

export type AccountInfoModalProps = {
  onCancel?: () => void;
  initialValue: string;
  shouldRender: boolean;
  forceNewNumber?: boolean;
} & Omit<ModalWithTwoFaProps, 'shouldShowContent'>;
